import {SelectEntityItem} from 'components/SelectEntityItem'
import _ from 'lodash'
import React from 'react'
import {notEmpty} from 'views/Shared'
import {yellowPageSchema} from "../../../apis";

const YellowPageEntity = ({item, children, defaultItem}) => (
    <SelectEntityItem
        item={item}
        defaultItem={defaultItem}
        schema={yellowPageSchema}>
        {(data) => children(data)}
    </SelectEntityItem>
)

export const YellowPageEntities = ({items, children, defaultItem}) => (
    <SelectEntityItem
        item={items}
        defaultItem={defaultItem}
        schema={[yellowPageSchema]}>
        {(data = []) => children(_.filter(data, notEmpty))}
    </SelectEntityItem>
)

export default YellowPageEntity
